import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";

import { FormEvent } from "../../form-factory";
import { FormField } from "../model/base";

import { FocusChangedEvent } from "./input-typeahead";

@Directive()
export abstract class InputBase {
  @Input()
  control!: FormControl;

  @Input()
  field!: FormField;

  @Input()
  notifications$!: Observable<FormEvent>;

  @Input()
  htmlIdPrefix?: string;

  @Output()
  focusChange = new EventEmitter<FocusChangedEvent>();

  protected onFocus() {
    const customFocusEvent: FocusChangedEvent = {
      event: "focus",
      field: this.field,
    };
    this.focusChange.emit(customFocusEvent);
  }

  protected onBlur() {
    const customFocusEvent: FocusChangedEvent = {
      event: "blur",
      field: this.field,
    };
    this.focusChange.emit(customFocusEvent);
  }
}
